import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content-box" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = {
  key: 0,
  class: "tax-mail-list"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "detail" }
const _hoisted_8 = { class: "section" }
const _hoisted_9 = { class: "detail" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "doc-list"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "label"
}
const _hoisted_14 = {
  key: 1,
  class: "desc"
}
const _hoisted_15 = { class: "section" }
const _hoisted_16 = { class: "desc" }

import { ref, computed } from 'vue';
import { RequestInfo } from '@/types/Request';
import { PaymentCycleTypeKeys} from "@/types/constants";
import { formatCurrency, formatPhonNumber, getBaPlanLName, getBeusPlanLName} from "@/utils";
import { getRequestTypeValue, getPaymentTypeValue, getPaymentCycleTypeValue, getDocumentTypeValue }  from '@/utils/getValueForKey';
import moment from "moment-timezone";


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewDetail',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

const isCopyTooltipVisible = ref(false);
const copyUserId = async(text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    isCopyTooltipVisible.value = true;
    setTimeout(() => {
      isCopyTooltipVisible.value = false;
    }, 1000);
  } catch (error) {
    console.error('텍스트 복사 실패:', error);
  }
}

const getPaymentAmountDetails = computed(() => {
  const cycleMap = {
    0: '',
    1: '매월',
    2: '격월마다',
    3: '분기마다',
    4: '4개월마다',
    6: '반기마다',
    12: ''
  }
  const amount = props.data ? props.data.payment.amount : 0
  const paymentCycle = props.data?.payment.paymentCycle ? props.data.payment.paymentCycle : 0
  const period = props.data?.payment.period ? props.data?.payment.period : 1 ;

  if(paymentCycle === 0 || paymentCycle === 12) {
    return '(일시납)'
  }

  const installment = amount / (period / paymentCycle);
  return `(${cycleMap[paymentCycle]} ${formatCurrency(installment)}원 납부)`

});

const calculatePaymentDates = (paymentCycle: PaymentCycleTypeKeys, paymentDate: string, period: number) => {
  const paymentStartDate = moment.tz(paymentDate[0], 'Asia/Seoul');
  if ([null, 0, 12].includes(paymentCycle)) {
    return paymentDate[0];
  }
  if (paymentCycle === 1) {
    if(props.data?.payment.isEndOfMonth) {
      return `${paymentDate[0]} (매월 말일)`;
    } else return `${paymentDate[0]} (매월 ${paymentStartDate.date()}일)`;
  }
  return paymentDate.join(", ");
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "tit-h3" }, " 고객 정보 ", -1)),
      _createElementVNode("dl", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("dt", null, "뷰져블 계정", -1)),
        _createElementVNode("dd", null, [
          _createTextVNode(_toDisplayString(_ctx.data.customer.customerId) + " ", 1),
          _createVNode(_component_el_tooltip, {
            visible: isCopyTooltipVisible.value,
            content: "뷰저블 계정이 복사되었습니다",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                link: "",
                "aria-label": "복사하기",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (copyUserId(_ctx.data.customer.customerId)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-copy" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["visible"])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("dt", null, [
          _createTextVNode("히트맵"),
          _createElementVNode("br"),
          _createTextVNode("추천인 코드")
        ], -1)),
        _createElementVNode("dd", null, _toDisplayString(_ctx.data.customer.beusRefer ? _ctx.data.customer.beusRefer : ''), 1),
        _cache[3] || (_cache[3] = _createElementVNode("dt", null, [
          _createTextVNode("저니맵"),
          _createElementVNode("br"),
          _createTextVNode(" 추천인 코드")
        ], -1)),
        _createElementVNode("dd", null, _toDisplayString(_ctx.data.customer.baRefer ? _ctx.data.customer.baRefer : ''), 1),
        _cache[4] || (_cache[4] = _createElementVNode("dt", null, "담당자 정보", -1)),
        _createElementVNode("dd", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.customer.manager, (manager) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "manager-item",
              key: manager.mail
            }, _toDisplayString(manager.name) + " (" + _toDisplayString(manager.mail) + _toDisplayString(manager.phone ? `, ${_unref(formatPhonNumber)(manager.phone)}` : '') + ") ", 1))
          }), 128))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("dt", null, [
          _createTextVNode("세금 계산서 "),
          _createElementVNode("br"),
          _createTextVNode(" 발행 정보")
        ], -1)),
        _createElementVNode("dd", null, [
          (_ctx.data.customer.taxInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.customer.taxInfo.taxInfoDetail, (mail) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "tax-mail-item",
                    key: mail
                  }, _toDisplayString(mail), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "N/A"))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "tit-h3" }, " 요청 상세 ", -1)),
      _createElementVNode("dl", _hoisted_7, [
        _cache[10] || (_cache[10] = _createElementVNode("dt", null, "요청 유형", -1)),
        _createElementVNode("dd", null, _toDisplayString(_unref(getRequestTypeValue)(_ctx.data.detail.requestType)), 1),
        (_ctx.data.detail.beusPlanNumber)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[7] || (_cache[7] = _createElementVNode("dt", null, "히트맵 플랜", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(getBeusPlanLName)(_ctx.data.detail.beusPlanNumber)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.data.detail.baPlanNumber)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[8] || (_cache[8] = _createElementVNode("dt", null, "저니맵 플랜", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(getBaPlanLName)(_ctx.data.detail.baPlanNumber)), 1)
            ], 64))
          : _createCommentVNode("", true),
        _cache[11] || (_cache[11] = _createElementVNode("dt", null, "사용 기간", -1)),
        _createElementVNode("dd", null, [
          _createTextVNode(_toDisplayString(_ctx.data.detail.useStartDate) + " ", 1),
          (_ctx.data.detail.useEndDate)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" ~ " + _toDisplayString(_ctx.data.detail.useEndDate), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.data.payment.period)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" (" + _toDisplayString(_ctx.data.payment.period) + "개월) ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_ctx.data.detail.recurring !== null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[9] || (_cache[9] = _createElementVNode("dt", null, "자동 갱신 여부", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.data.detail.recurring ? 'Y' : 'N'), 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "tit-h3" }, " 결제 정보 ", -1)),
      _createElementVNode("dl", _hoisted_9, [
        (_ctx.data.payment.paymentType === 'free')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" 무상 제공 ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[14] || (_cache[14] = _createElementVNode("dt", null, "결제 유형", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(getPaymentTypeValue)(_ctx.data.payment.paymentType)), 1),
              (_ctx.data.payment.paymentCycle && _ctx.data.payment.paymentCycle > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[13] || (_cache[13] = _createElementVNode("dt", null, "결제 주기", -1)),
                    _createElementVNode("dd", null, _toDisplayString(_unref(getPaymentCycleTypeValue)(_ctx.data.payment.paymentCycle)), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _cache[15] || (_cache[15] = _createElementVNode("dt", null, "총 결제 금액", -1)),
              (_ctx.data)
                ? (_openBlock(), _createElementBlock("dd", _hoisted_10, _toDisplayString(_unref(formatCurrency)(_ctx.data.payment.amount) + ' 원') + " " + _toDisplayString(getPaymentAmountDetails.value), 1))
                : _createCommentVNode("", true),
              _cache[16] || (_cache[16] = _createElementVNode("dt", null, "결제일", -1)),
              _createElementVNode("dd", null, _toDisplayString(calculatePaymentDates(_ctx.data.payment.paymentCycle, _ctx.data.payment.paymentDate, _ctx.data.payment.period)), 1),
              _cache[17] || (_cache[17] = _createElementVNode("dt", null, "서류 발행", -1)),
              _createElementVNode("dd", null, [
                (_ctx.data.payment.docs && _ctx.data.payment.docs.length > 0)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.payment.docs, (doc, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createTextVNode(_toDisplayString(doc.actionDate) + " / " + _toDisplayString(_unref(getDocumentTypeValue)(doc.docType)) + " / ", 1),
                          (doc.email === 'system')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "별도 시스템(메모 참고)"))
                            : (typeof doc.email === 'string')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(doc.email), 1))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(doc.email, (mail) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: mail,
                                    class: "label"
                                  }, _toDisplayString(mail), 1))
                                }), 128))
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_14, " N/A "))
              ])
            ], 64))
      ])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "tit-h3" }, " 메모 ", -1)),
      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.data.memo.length === 0 ? '-' : _ctx.data.memo), 1)
    ])
  ]))
}
}

})